import { Outlet, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import "../styles/Sidebar.css";

const ProtectedLayout = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Check for authentication
  const token = localStorage.getItem("authToken");
  if (!token) {
    return <Navigate to="/" />;
  }

  return (
    <div className={`layout ${isMobile ? 'mobile-layout' : ''}`}>
      <Sidebar />
      <div className="main-content">
        <Outlet />
      </div>
    </div>
  );
};

export default ProtectedLayout;
